import React from "react";
import {
  Box,
  Flex,
  Icon,
  IconButton,
  useColorModeValue,
} from "@chakra-ui/react";
import { FiMenu } from "react-icons/fi";
import { Logo } from "./Logo";
import { ThemeToggle } from "./ThemeToggle";

interface MobileTopBarProps {
  onOpen: () => void;
}

export const MobileTopBar: React.FC<MobileTopBarProps> = ({ onOpen }) => {
  const bg = useColorModeValue("rgba(255,255,255,0.85)", "rgba(15,28,49,0.85)");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  return (
    <Flex
      w="100%"
      px={4}
      py={3}
      align="center"
      justify="space-between"
      position="relative"
      bg={bg}
      backdropFilter="blur(10px)"
      borderBottom="1px solid"
      borderColor={borderColor}
      flexShrink={0}
    >
      {/* Hamburger — left */}
      <IconButton
        aria-label="Open menu"
        icon={
          <Icon verticalAlign="middle" as={FiMenu as any} fontSize={"24px"} />
        }
        variant="ghost"
        onClick={onOpen}
      />

      {/* Logo — absolutely centered */}
      <Box
        position="absolute"
        left="50%"
        transform="translateX(-50%)"
        pointerEvents="none"
      >
        <Box pointerEvents="auto">
          <Logo variant="horizontal" w="130px" to="/" />
        </Box>
      </Box>

      {/* Theme toggle — right */}
      <ThemeToggle />
    </Flex>
  );
};
